/**
 * Canonical role detection for the notifications feature.
 * Mirrors the checkReadOnly pattern in SideNav.js but returns a named role.
 *
 * Roles:
 *   manager       - salon owner (isSalonOwner === 1)
 *   self_employed - self-employed stylist (employmentTypeId === 2, not owner)
 *   employee      - regular salon employee
 */
export const getNotificationRole = (user) => {
  const h = user?.userInfo?.hairdresser;
  if (h?.isSalonOwner === 1) return 'manager';
  if (h?.employmentTypeId === 2) return 'self_employed';
  return 'employee';
};

export const isManagerRole = (role) => role === 'manager';

export const getOwnHairdresserId = (user) => {
  return user?.userInfo?.hairdresser?._id
    || user?.userInfo?.hairdresser?.hairdresserId
    || localStorage.getItem('userId')
    || null;
};
